import React from "react";
import { SkeletonAvatar, SkeletonText, SkeletonButton } from "@calcom/ui";
import { useIsEmbed } from "@calcom/embed-core/embed-iframe";
import classNames from "@calcom/lib/classNames";

function BookingPageSkeleton() {
  const isEmbed = useIsEmbed();

  return (
    <main
      className={classNames(
        !isEmbed ? "mx-auto" : "",
        isEmbed ? "h-full w-full" : "max-w-4xl sm:my-24",
        "my-0"
      )}>
      <div
        className={classNames(
          "main dark:border-darkgray-300 dark:bg-darkgray-100 overflow-hidden rounded-md bg-white dark:border",
          isEmbed ? "h-full w-full" : ""
        )}>
        <div className={classNames("sm:flex", isEmbed && "h-full w-full")}>
          <div
            className={classNames(
              "dark:border-darkgray-300 dark:text-darkgray-600 flex flex-col text-gray-600 sm:w-1/2 sm:border-r",
              isEmbed ? "px-6 pb-0 pt-6 sm:pb-6 md:px-10 md:pb-10 md:pt-10" : "px-6 pb-0 pt-6 sm:pb-6 md:p-6"
            )}>
            <SkeletonAvatar className="mb-2 h-9 w-9" />

            <h2 className="mt-2 text-sm font-medium text-gray-600 dark:text-gray-300">
              <SkeletonText className="h-4 w-32" />
            </h2>

            <h1 className="font-cal dark:text-darkgray-900 mb-3 mt-2 flex flex-col gap-1 text-2xl font-semibold text-gray-900">
              <SkeletonText className={classNames("h-8 w-11/12", isEmbed ? "md:h-10" : "")} />
              <SkeletonText className={classNames("h-8 w-3/4", isEmbed ? "md:h-10" : "")} />
            </h1>

            <div className="dark:text-darkgray-600 flex flex-col space-y-2 text-sm font-medium text-gray-600">
              <div className="flex items-center">
                <SkeletonText className={classNames("mr-2 h-4 w-4", isEmbed ? "md:h-6 md:w-6" : "")} />
                <SkeletonText className={classNames("h-4 w-28", isEmbed ? "md:h-5" : "")} />
              </div>

              <div className="flex items-center">
                <SkeletonText className={classNames("mr-2 h-4 w-4", isEmbed ? "md:h-6 md:w-6" : "")} />
                <SkeletonText className={classNames("h-4 w-24", isEmbed ? "md:h-5" : "")} />
              </div>

              <div className="flex items-start">
                <SkeletonText
                  className={classNames("mr-2 mt-[2px] h-4 w-4", isEmbed ? "md:h-6 md:w-6" : "")}
                />
                <SkeletonText className={classNames("h-4 w-56", isEmbed ? "md:h-5" : "")} />
              </div>
            </div>
          </div>

          <div className={classNames("flex flex-col sm:w-1/2", isEmbed ? "p-6 md:p-10" : "p-6")}>
            <div className={classNames(isEmbed ? "mb-2 md:mb-4" : "mb-2")}>
              <label className={classNames("mb-1 block", isEmbed ? "text-sm md:text-lg" : "text-sm")}>
                <SkeletonText className={classNames("h-4 w-24", isEmbed ? "md:h-5 md:w-28" : "")} />
              </label>
              <SkeletonText
                className={classNames("mt-1 w-full rounded-md", isEmbed ? "h-9 md:h-11" : "h-9")}
              />
            </div>

            <div className={classNames(isEmbed ? "mb-2 md:mb-4" : "mb-2")}>
              <label className={classNames("mb-1 block", isEmbed ? "text-sm md:text-lg" : "text-sm")}>
                <SkeletonText className={classNames("h-4 w-32", isEmbed ? "md:h-5 md:w-36" : "")} />
              </label>
              <SkeletonText
                className={classNames("mt-1 w-full rounded-md", isEmbed ? "h-9 md:h-11" : "h-9")}
              />
            </div>

            <div className={classNames(isEmbed ? "mb-2 md:mb-4" : "mb-2")}>
              <label className={classNames("mb-1 block", isEmbed ? "text-sm md:text-lg" : "text-sm")}>
                <SkeletonText className={classNames("h-4 w-40", isEmbed ? "md:h-5" : "")} />
              </label>
              <SkeletonText
                className={classNames("mt-1 w-full rounded-md", isEmbed ? "h-16 md:p-4" : "h-12")}
              />
            </div>

            <div className="mb-2 mt-1 flex items-center">
              <SkeletonText className="mr-2 h-4 w-4" />
              <SkeletonText className="h-4 w-32" />
            </div>

            <div
              className={classNames(
                "mt-2 flex justify-end rtl:space-x-reverse",
                isEmbed ? "space-x-2 md:space-x-4" : "space-x-3"
              )}>
              <SkeletonButton
                className={classNames("w-24", isEmbed ? "h-9 md:h-11 md:w-24 md:px-6 md:py-3" : "h-9")}
              />
              <SkeletonButton
                className={classNames("w-32", isEmbed ? "h-9 md:h-11 md:w-32 md:px-8 md:py-4" : "h-9")}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default BookingPageSkeleton;
